/*

  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign

  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page

  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner

*/
(function(){

	"use strict";

	/* In case you want to output a bunch of things to the debug console */
	var debug = true;
	var cartCookie;

	/* The ID of the element that you want to add the shipping fields into */
	var productSection = document.getElementById('jd-shipping-calculator');
	//if(!productSection.length){ log('Could not find the element'); return }

	/* the main product select element */
	var productSelect = document.getElementsByClassName('product-variant-id')[0];
      
     var _config = {
            submitButton: "Calculate shipping rates",
            submitButtonDisabled: "Calculating...",
            templateId: "shipping-calculator-response-template",
            wrapperId: "wrapper-response",
            customerIsLoggedIn: !1,
            moneyFormat: "${{amount}}"
        };
//if(!productSelect){ log('Could not find the main select element'); return }
	/* create a message box */
	var shippingMessage = document.createElement('p');
    var SelectWrapper1 =  document.createElement('div');
    SelectWrapper1.className = 'four columns alpha select-country';
  var SelectWrapper2 =  document.createElement('div');
    SelectWrapper2.className = 'state nine columns alpha';
    var SelectWrapper3 =  document.createElement('div');
    SelectWrapper3.className = 'zip seven columns';
    var SelectWrapper4 =  document.createElement('div');
    SelectWrapper4.className = '';
    var MessageWrapper = document.createElement('div');
   MessageWrapper.className = 'wrapper-response';
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');
     var shippingBeforeMessage = document.createElement('p');
    var _ErrorMessage = document.createElement('p');
 	var _enableButtons = function() {
            jQuery(".get-rate").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)
        };
    var _disableButtons = function() {
            jQuery(".get-rate").val(_config.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled")
        };
	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){

		/* create the country picker */
		var countries = ['Australia'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		/* create the province state picker */

		var provinces = ['Australian Capital Territory','New South Wales','Northern Territory', 'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia'];
		for (var i = 0; i < provinces.length; i++) {
			shippingProvince.add(new Option(provinces[i], provinces[i], i===0));
		};
		shippingProvince.name = 'shipping_address[province]';

		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';

		/* create a wrapper for the fields */
		var shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper clearfix sixteen columns';
        

		/* create a title */
		var shippingCalcTitle = document.createElement('h4');
		shippingCalcTitle.innerText = 'Shipping rates calculator';

		/* create a get rates button */
		var shippingCalcButton = document.createElement('INPUT');
        shippingCalcButton.setAttribute("type", "button");
        shippingCalcButton.setAttribute("value", "Calculate shipping rates");
		shippingCalcButton.innerText = 'Calculate shipping rates';
		shippingCalcButton.className = 'btn get-rate';
		shippingCalcButton.onclick=function(){
			//if(!productSelect.value.length){ return false }
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				//log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				//log('cookie found');
			}
		    _disableButtons();
			/* if found but has a weird length, bail */
			//if(cartCookie.length < 32){ log('cart ID not valid');return }

			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
//log(getCookie('cart'));
			
			getRates(parseInt(productSelect.value));
			return false;
		};

		/* create some labels for the fields */
		var labelNames = ['Country','State','Postal Code'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};

		shippingCalcWrapper.appendChild(shippingCalcTitle);
		SelectWrapper1.appendChild(labels[0]);
		SelectWrapper1.appendChild(shippingCountry);
		SelectWrapper2.appendChild(labels[1]);
       SelectWrapper2.appendChild(shippingProvince);
      SelectWrapper3.appendChild(labels[2]);
		SelectWrapper3.appendChild(shippingZip);
        SelectWrapper4.appendChild(shippingCalcButton);
      shippingCalcWrapper.appendChild(SelectWrapper1);
      shippingCalcWrapper.appendChild(SelectWrapper2);
      shippingCalcWrapper.appendChild(SelectWrapper3);
      shippingCalcWrapper.appendChild(SelectWrapper4);
      MessageWrapper.appendChild(shippingBeforeMessage);
		MessageWrapper.appendChild(shippingMessage);
     MessageWrapper.appendChild(_ErrorMessage);
		
		/* add to the page */
		//productSection[0].appendChild(shippingCalcWrapper);
        //productSection[0].appendChild(MessageWrapper);
		// if (productSection.nextSibling) {
  //         productSection[0].parentNode.insertBefore(shippingCalcWrapper, productSection.nextSibling);
  //         productSection[0].parentNode.insertBefore(MessageWrapper, productSection.nextSibling);
  //       }
        // else {
          productSection.appendChild(shippingCalcWrapper);
          productSection.appendChild(MessageWrapper);
        // }
	};

	/* A console logging function */
	var log = function(a){
		if(!debug){ return }
		console.log(a);
	};

	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		//log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};

	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		//log(getCookie('cart'));
	};
    var isZipCode = function is_usZipCode(str)
      {
       regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;

              if (regexp.test(str))
                {
                  return true;
                }
              else
                {
                  return false;
                }
      };
  	
    var _formatRate = function(e) {
            function t(e, t) {
                return "undefined" == typeof e ? t : e
            }

            function r(e, r, n, a) {
                if (r = t(r, 2), n = t(n, ","), a = t(a, "."), isNaN(e) || null == e) return 0;
                e = (e / 100).toFixed(r);
                var i = e.split("."),
                    o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
                    s = i[1] ? a + i[1] : "";
                return o + s
            }
            if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(e, _config.moneyFormat);
            "string" == typeof e && (e = e.replace(".", ""));
            var n = "",
                a = /\{\{\s*(\w+)\s*\}\}/,
                i = _config.moneyFormat;
            switch (i.match(a)[1]) {
                case "amount":
                    n = r(e, 2);
                    break;
                case "amount_no_decimals":
                    n = r(e, 0);
                    break;
                case "amount_with_comma_separator":
                    n = r(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    n = r(e, 0, ".", ",")
            }
            return i.replace(a, n)
        };
  	
	/* get the rates */
	var getRates = function(variantId){

		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined'){ return }

		/* the main quantity element */
		var productQuantity = document.getElementsByClassName('quantity');
        //console.log(variantId);
		var quantity = 1;
		var addData = {
			'id':variantId,
			'quantity':quantity
		};

		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			/* we have JSON */
            _enableButtons();
			//console.log(json);
			/* Change the cookie value back to what it was */
          if(shippingZip.value == ''){
            _ErrorMessage.innerHTML = 'Error: zip can\'t be blank.';
          }else{
            _ErrorMessage.innerHTML = '';
          }
			$.ajax({
				type: "GET",
				url: '/cart/shipping_rates.json',
				data: {
					'shipping_address[country]':shippingCountry.value,
					'shipping_address[province]':shippingProvince.value,
					'shipping_address[zip]':shippingZip.value
				},
				success: function(d){
					if(d.shipping_rates && d.shipping_rates.length){
                       shippingBeforeMessage.innerHTML = '';
                       shippingMessage.innerHTML = d.shipping_rates[0].name+' at '+_formatRate(d.shipping_rates[0].price);
                      var wizards = [d.shipping_rates[0].name+' at '+d.shipping_rates[0].price];

                      wizards.forEach(function (wizard) {
                            var li = document.createElement('li');
                            li.textContent = wizard;
                            //shippingMessage.appendChild(li);
                        });
                    }
					resetCartCookie()
				},
				error: function(){
					resetCartCookie();
					shippingMessage.innerHTML = '';
                   shippingBeforeMessage.innerHTML = 'No shipping could be found for your address.';
				},
				dataType: 'json'
			});
			
			
		}).catch(function(err) {
			/* uh oh, we have error. */
			console.error(err);
			resetCartCookie()
		});

	};

	initFields();

})()